<template>
  <div id="pageRoot">
    <img id="bg" src="/pages/img/sordoglo/svgGlo17bg.svg" />

    <span class="normalTheme pageInstruction" style="left: 67px; top: 111px">
      <p>Escribe el nombre de cada animal.</p>
    </span>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputFieldFly"
      style="height: 40px"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputFieldSnail"
      style="height: 40px"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputFieldTort"
      style="height: 40px"
    />

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="4"
      id="inputFieldDuck"
      style="height: 40px"
    />

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="5"
      id="inputFieldCrab"
      style="height: 40px"
    />

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="6"
      id="inputFieldFrog"
      style="height: 40px"
    />

    <img
      id="title"
      class="appearAnimationA"
      src="/pages/img/sordoglo/svgGlo17Title.svg"
    />
    <img
      id="tortoise"
      class="pageElement basicItem01"
      src="/pages/img/sordoglo/svgGlo17TortoiseRiver.svg"
    />
    <img
      id="fly"
      class="pageElement basicItem01"
      src="/pages/img/sordoglo/svgGlo7Fly.svg"
    />
    <img
      id="snail"
      class="pageElement basicItem01"
      src="/pages/img/sordoglo/svgGlo8Snail.svg"
    />

    <img
      id="crab"
      class="pageElement basicItem01"
      src="/pages/img/sordoglo/svgGlo8Crab.svg"
    />
    <img
      id="duck"
      class="pageElement basicItem01"
      src="/pages/img/sordoglo/svgGlo17DuckRiver.svg"
    />
    <img
      id="toad"
      class="pageElement basicItem01"
      src="/pages/img/sordoglo/svgGlo11Toad.svg"
    />
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 6.35px;
  top: 60px;
}

#inputFieldFly {
  position: absolute;
  width: 228px;
  height: 30px;
  left: 406px;
  top: 282px;
  z-index: 1;
}
#inputFieldSnail {
  position: absolute;
  width: 228px;
  height: 30px;
  left: 738px;
  top: 403px;
  z-index: 1;
}
#inputFieldTort {
  position: absolute;
  width: 228px;
  height: 30px;
  left: 47px;
  top: 442px;
  z-index: 1;
}
#inputFieldDuck {
  position: absolute;
  width: 228px;
  height: 32px;
  left: 442px;
  top: 500px;
  z-index: 3;
}
#inputFieldCrab {
  position: absolute;
  width: 228px;
  height: 30px;
  left: 133px;
  top: 678px;
  z-index: 1;
}
#inputFieldFrog {
  position: absolute;
  width: 228px;
  height: 30px;
  left: 599px;
  top: 670px;
  z-index: 1;
}
#title {
  position: absolute;
  left: 68px;
  top: 15px;
}
#tortoise {
  position: absolute;
  left: 85px;
  top: 273px;
}
#fly {
  position: absolute;
  left: 396px;
  top: 138px;
}
#snail {
  position: absolute;
  left: 787px;
  top: 257px;
}

#crab {
  position: absolute;
  left: 61px;
  top: 560px;
}
#duck {
  position: absolute;
  left: 473px;
  top: 358px;
  z-index: 1;
}
#toad {
  position: absolute;
  left: 735px;
  top: 514px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["glo/Video 82b.mp4"]
    }
  }
}
</script>